import React from 'react';
import { IEditorProps } from './props-interfaces';
import { Uploader } from './uploader';

export const ZipEditor = (props: IEditorProps) =>
<Uploader {...props}
    acceptedExtensions={[ "zip" ]}
    showDownload={true}
    downloadQuery="recursive&zip"
    messages={[ '', 'Upload a zip file for contents to be extracted to this location' ]} />